import { toast } from 'react-toastify';
import useSWR from 'swr';
import { getAgendaAberta } from '../services/medico';

const FILTRO_ATIVIDADE = {
  BIOIMPEDANCIA: 'BIOIMPEDANCIA',
  ECO: 'ECO',
  'ECO-FETAL': 'ECO-FETAL',
  CONSULTA: 'CONSULTA',
  HOLTER: 'HOLTER',
  MAPA: 'MAPA',
};

const procedimentosAgendaAberta = codMedico => {
  if (codMedico === 4860) return 'CONSULTA,ECO,ECO-FETAL';
  if (codMedico === 1981) return 'BIOIMPEDANCIA';
  if (codMedico === 2921) return 'HOLTER,MAPA';
  return 'CONSULTA';
};

const fetchAgendaAberta = async ([, id, dt, procedimentos, procedimento]) => {
  const dados = await getAgendaAberta({ id, dt, procedimentos });
  const filtro = FILTRO_ATIVIDADE[procedimento];
  if (!filtro) return dados;
  return dados.filter(item => item.ATIVIDADE === filtro);
};

const EMPTY_HORARIOS = [];

const useAgendaAberta = (codMedico, dateAgendaFormatted, procedimento) => {
  const shouldFetch = Number.isFinite(codMedico) && Boolean(dateAgendaFormatted);

  const { data, error, isLoading } = useSWR(
    shouldFetch
      ? [
          'agendaaberta',
          codMedico,
          dateAgendaFormatted,
          procedimentosAgendaAberta(codMedico),
          procedimento,
        ]
      : null,
    fetchAgendaAberta,
    {
      keepPreviousData: false,
      revalidateOnFocus: false,
      shouldRetryOnError: false,
      onError: err => {
        toast.error(
          err?.response?.data?.error || 'Erro ao buscar horários disponíveis!'
        );
      },
    }
  );

  return {
    horariosAgenda: data ?? EMPTY_HORARIOS,
    carregandoHorarios: isLoading,
    erroHorarios: error,
  };
};

export default useAgendaAberta;
